(function() {
    let currentIndex = 0;
    const track = document.querySelector('.slider-track');
    const prevBtn = document.querySelector('.slider-btn.prev');
    const nextBtn = document.querySelector('.slider-btn.next');
    
    if (!track) return;
    
    function updateSlidePosition() {
        const slides = document.querySelectorAll('.slide');
        const totalSlides = slides.length;
        if (totalSlides === 0) return;
        
        let slidesPerView = 3;
        if (window.innerWidth <= 768) {
            slidesPerView = 1;
        }
        
        let maxIndex = totalSlides - slidesPerView;
        if (maxIndex < 0) maxIndex = 0;
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;
        
        const slideNode = slides[0];
        if (!slideNode) return;
        
        const gap = parseInt(getComputedStyle(track).gap) || 0;
        let scrollAmount = 0;
        for (let i = 0; i < currentIndex; i++) {
            if (slides[i]) {
                scrollAmount += slides[i].offsetWidth + gap;
            }
        }
        
        track.style.transform = `translateX(-${scrollAmount}px)`;
    }
    
    function moveSlide(direction) {
        const slides = document.querySelectorAll('.slide');
        const totalSlides = slides.length;
        if (totalSlides === 0) return;
        
        let slidesPerView = 3;
        if (window.innerWidth <= 768) {
            slidesPerView = 1;
        }
        
        const maxIndex = Math.max(0, totalSlides - slidesPerView);
        currentIndex += direction;
        
        if (currentIndex < 0) {
            currentIndex = 0;
        } else if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
        }
        
        updateSlidePosition();
    }
    
    if (prevBtn) {
        prevBtn.addEventListener('click', function() { moveSlide(-1); });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', function() { moveSlide(1); });
    }
    
    let touchStartX = 0;
    track.addEventListener('touchstart', function(e) { 
        touchStartX = e.changedTouches[0].screenX; 
    }, {passive: true});
    track.addEventListener('touchend', function(e) {
        let touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) moveSlide(1);
        if (touchEndX - touchStartX > 50) moveSlide(-1);
    }, {passive: true});
    
    window.addEventListener('resize', function() {
        updateSlidePosition();
    });
    
    updateSlidePosition();
})();